export default __webpack_public_path__ + "static/media/main-featured-img.f90b066d.png";